import { render, staticRenderFns } from "./ExistingFuneralPlanYN.vue?vue&type=template&id=1072e5a8"
import script from "./ExistingFuneralPlanYN.vue?vue&type=script&lang=js"
export * from "./ExistingFuneralPlanYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports